'use client';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/**
 * Loading boundary for carteira tab and fundo (ativo) tab navigations.
 *
 * Deliberately louder than a bare centered spinner: the tab bar and the
 * summary header stay server-rendered until the new tab's payload
 * arrives, so the old content would otherwise sit frozen with no
 * visible change (the report that motivated this file). The progress
 * bar pinned to the top of the content area makes the navigation state
 * unmissable, and the card skeletons reserve the layout to avoid a
 * jarring swap when data lands.
 */
export const TabLoadingSkeleton = () => {
  return (
    <Box role='status' aria-label='Carregando' data-portfolio-tab-loading>
      <LinearProgress sx={{ mb: 2 }} />
      <Stack spacing={2} sx={{ px: { xs: 2, md: 3 }, py: 2 }}>
        <Skeleton variant='rounded' height={40} width='55%' />
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          <Skeleton variant='rounded' height={90} width='50%' />
          <Skeleton variant='rounded' height={90} width='50%' />
        </Stack>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          <Skeleton variant='rounded' height={90} width='50%' />
          <Skeleton variant='rounded' height={90} width='50%' />
        </Stack>
        <Skeleton variant='rounded' height={320} />
      </Stack>
    </Box>
  );
};

export default TabLoadingSkeleton;
